export default __webpack_public_path__ + "static/media/03.4d312b03.png";